import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DobCheckModalComponent } from '../dob-check-modal/dob-check-modal.component';
import { ReducerUtilityService, StateStructure } from '@ptl/state';



@Component({
  selector: 'app-dob-check-modal-trigger',
  templateUrl: './dob-check-modal-trigger.component.html',
  styleUrl: './dob-check-modal-trigger.component.scss',
  standalone: false
})
export class DobCheckModalTriggerComponent implements OnInit{

  showModal: boolean = true;
  
  @Input() modalHeading;
  @Input() modalSubheading;
  @Input() modalChildOnlySubheading;
  @Input() modalButtonLabel;
  @Input() modalErrorMessage;
  @Input() disabledLinkUrl


  constructor(
    private matDialog: MatDialog,
    private reducerUtilityService: ReducerUtilityService,

  ) { }

  ngOnInit(): void {
    const referralId = this.reducerUtilityService.getComponentStates().GlobalData.urlParams.referralid;
    const isAuthorized = this.reducerUtilityService.getComponentStates().SavedQuotes.authorized;
    

    if(referralId && !isAuthorized){
      this.openDobCheckModal()
    }

  }

  openDobCheckModal(){
    this.matDialog.open(DobCheckModalComponent, {
      maxWidth: '650px',
      maxHeight: '100vh',
      disableClose: true,
      data: {
        disabledLinkUrl: this.disabledLinkUrl,
        modalContent: {
          heading: this.modalHeading,
          subheading: this.modalSubheading,
          childOnlySubheading: this.modalChildOnlySubheading,
          buttonLabel: this.modalButtonLabel,
          errorMessage: this.modalErrorMessage
        }
      }
    });
  }
}

